export const UnsupportedImageSuffix = {
  APNG: '.apng',
  AVIF: '.avif',
  GIF: '.gif',
  SVG: '.svg'
};
export const UNSUPPORTED_AI_IMAGE_EXTENSIONS = Object.values(UnsupportedImageSuffix);
export let DisabledButtonTooltipKeySuffix = /*#__PURE__*/function (DisabledButtonTooltipKeySuffix) {
  DisabledButtonTooltipKeySuffix["SITE_NOT_PREMIUM"] = "site-not-premium";
  DisabledButtonTooltipKeySuffix["NO_MISSING_ALT_TEXT"] = "no-missing-alt-text";
  DisabledButtonTooltipKeySuffix["ALL_SVG"] = "all-svg";
  DisabledButtonTooltipKeySuffix["ALL_GIF"] = "all-gif";
  DisabledButtonTooltipKeySuffix["ALL_AVIF"] = "all-avif";
  DisabledButtonTooltipKeySuffix["ALL_APNG"] = "all-apng";
  DisabledButtonTooltipKeySuffix["ALL_MIX_UNSUPPORTED"] = "all-mix-unsupported";
  DisabledButtonTooltipKeySuffix["FAIL_TO_AI"] = "fail-to-ai";
  return DisabledButtonTooltipKeySuffix;
}({});
export const getDisabledButtonTooltipKeySuffix = (items, isGenerating) => {
  if (isGenerating) {
    return undefined;
  }
  if (!(items != null && items.length) || items.length === 0) {
    return DisabledButtonTooltipKeySuffix.NO_MISSING_ALT_TEXT;
  }
  const allSvg = items.every(_ref => {
    let {
      url
    } = _ref;
    return url.toLowerCase().endsWith(UnsupportedImageSuffix.SVG);
  });
  if (allSvg) {
    return DisabledButtonTooltipKeySuffix.ALL_SVG;
  }
  const allGif = items.every(_ref2 => {
    let {
      url
    } = _ref2;
    return url.toLowerCase().endsWith(UnsupportedImageSuffix.GIF);
  });
  if (allGif) {
    return DisabledButtonTooltipKeySuffix.ALL_GIF;
  }
  const allAvif = items.every(_ref3 => {
    let {
      url
    } = _ref3;
    return url.toLowerCase().endsWith(UnsupportedImageSuffix.AVIF);
  });
  if (allAvif) {
    return DisabledButtonTooltipKeySuffix.ALL_AVIF;
  }
  const allApng = items.every(_ref4 => {
    let {
      url
    } = _ref4;
    return url.toLowerCase().endsWith(UnsupportedImageSuffix.APNG);
  });
  if (allApng) {
    return DisabledButtonTooltipKeySuffix.ALL_APNG;
  }
  const allMixUnsupported = items.every(_ref5 => {
    let {
      url
    } = _ref5;
    return UNSUPPORTED_AI_IMAGE_EXTENSIONS.some(suffix => url.toLowerCase().endsWith(suffix));
  });
  if (allMixUnsupported) {
    return DisabledButtonTooltipKeySuffix.ALL_MIX_UNSUPPORTED;
  }
  return undefined;
};
export const isAiSupportedImageFormat = url => {
  return !UNSUPPORTED_AI_IMAGE_EXTENSIONS.some(suffix => url.toLowerCase().endsWith(suffix));
};
export const getSingleImageDisabledTooltipKeySuffix = url => {
  const lowerUrl = url.toLowerCase();
  if (lowerUrl.endsWith(UnsupportedImageSuffix.SVG)) {
    return DisabledButtonTooltipKeySuffix.ALL_SVG;
  }
  if (lowerUrl.endsWith(UnsupportedImageSuffix.GIF)) {
    return DisabledButtonTooltipKeySuffix.ALL_GIF;
  }
  if (lowerUrl.endsWith(UnsupportedImageSuffix.AVIF)) {
    return DisabledButtonTooltipKeySuffix.ALL_AVIF;
  }
  if (lowerUrl.endsWith(UnsupportedImageSuffix.APNG)) {
    return DisabledButtonTooltipKeySuffix.ALL_APNG;
  }
  return undefined;
};
//# sourceMappingURL=get-disabled-button-tooltip-key.js.map